import BaseApiServer1Service from "./BaseApiServer1Service";

class GoogleMapApiServerService extends BaseApiServer1Service {
  /**
   * @param {String} id
   * @returns Promise<Object>
   * @memberof SearchService
   */

  async getLocation(userIp?: string) {
    const response = await this.apiGet(`/api/ip/json/region?ipAddress=${userIp}`, userIp);
    return response;
  }
}
export default new GoogleMapApiServerService();
